import type {
  OrderGetResponseType,
  OrderShippingRequestItemType,
} from "@sellar-io/api-v2/types";
import { ReactElement, ReactNode, useState } from "react";
import { OrderCreateShippingContext } from "../contexts/OrderCreateShippingContext";

export const CreateShipmentProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const [items, setItems] = useState<
    (OrderGetResponseType["OrderItems"][number] & { itemId: number })[]
  >([]);
  const [boxes, setBoxes] = useState<OrderShippingRequestItemType[]>([]);

  return (
    <OrderCreateShippingContext.Provider
      value={{
        items,
        setItems,
        boxes,
        setBoxes,
      }}
    >
      {children}
    </OrderCreateShippingContext.Provider>
  );
};
